if (!customElements.get("m-recently-viewed")) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper"
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const component = tempDiv.querySelector("m-recently-viewed");
          this.products = component.querySelectorAll(".m-product-card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (component && component.innerHTML.trim().length) {
            this.innerHTML = component.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });
            MinimogTheme.CompareProduct.setCompareButtonsState();
            MinimogTheme.Wishlist.setWishlistButtonsState();
          }
        })
        .catch(error => {
          console.error("Error fetching recently viewed products:", error);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;

      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        if (slideControls) slideControls.classList.add("m:hidden");
        if (slideContainer) slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        if (slideControls) slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (this.products <= parseInt(this.items) && slideControls) {
        slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controls = this.querySelector(".m-slider-controls");
      const prevButton = controls && controls.querySelector(".m-slider-controls__button-prev");
      const nextButton = controls && controls.querySelector(".m-slider-controls__button-next");
      const slideCount = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      if (slideContainer) slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: !(this.products <= parseInt(this.items)),
        pagination: this.showPagination ? {
          el: this.querySelector(".swiper-pagination"),
          clickable: true
        } : false,
        breakpoints: {
          768: { slidesPerView: Math.max(3, parseInt(this.items)) },
          1024: { slidesPerView: Math.max(4, parseInt(this.items)) },
          1280: { slidesPerView: parseInt(this.items) }
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              const image = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (image && controls) {
                const offsetHeight = image.clientHeight;
                controls.style.setProperty("--offset-top", `${offsetHeight / 2}px`);
                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, { slidesPerView }) => {
            if (controls) {
              if (slideCount > slidesPerView) {
                controls.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controls.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          }
        }
      });

      if (this.slider && this.showNavigation) {
        if (prevButton) prevButton.addEventListener("click", () => this.slider.slidePrev());
        if (nextButton) nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer && slideContainer.swiper;
    }

    getQueryString() {
      const recentlyViewed = JSON.parse(window.localStorage.getItem("minimog-recently-viewed") || "[]");
      if (this.dataset.productId && recentlyViewed.includes(parseInt(this.dataset.productId))) {
        recentlyViewed.splice(recentlyViewed.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return recentlyViewed.map(id => `id:${id}`).slice(0, this.productsToshow).join(" OR ");
    }
  }

  customElements.define("m-recently-viewed", RecentlyViewed);
}
